import React from 'react';
import { Link } from 'react-router-dom';
import * as Styles from 'pages/Intro/styles';
import coinplug_logo from 'assets/coinplug-logo-horizo.png';

class Intro extends React.Component {
  render() {
    return(
      <Styles.PageLayout>
        <Styles.GridLayout>
          {/* 최상단 coinplug logo */}
          <Styles.LogoContainer>
            <Styles.Logo src={coinplug_logo} alt="coinplug-logo" />
          </Styles.LogoContainer>
          {/* 상단 페이지 제목 */}
          <Styles.PageTitle>
            TITLE OF SAMPLE SP
          </Styles.PageTitle>
          {/* 샘플 텍스트 */}
          <Styles.Paragraph>
            This is where you will find a description of the service. You need a description of the authentication that does not receive VP. Longer positioning for testing. It doesn't matter if you enter multiple paragraphs.
          </Styles.Paragraph>
          {/* 페이지 이동 버튼들, 누르면 각각에 해당하는 페이지로 이동함 */}
          <Styles.ButtonContainer>
            {/* functio1, i.e. auth sample */}
            <Link to="/function1">
              <Styles.ButtonWrapper>
                <Styles.Button> Auth sample </Styles.Button>
              </Styles.ButtonWrapper>
            </Link>
            {/* functio2, i.e. vp sample */}
            <Link to="/function2">
              <Styles.ButtonWrapper>
                <Styles.Button> VP sample </Styles.Button>
              </Styles.ButtonWrapper>
            </Link>
            {/* functio3, i.e. push sample */}
            <Link to="/function3">
              <Styles.ButtonWrapper>
                <Styles.Button> Push sample </Styles.Button>
              </Styles.ButtonWrapper>
            </Link>
            {/* function4, i.e. popup sample */}
            <Link to="/function4">
              <Styles.ButtonWrapper>
                <Styles.Button> Popup sample </Styles.Button>
              </Styles.ButtonWrapper>
            </Link>
          </Styles.ButtonContainer>
        </Styles.GridLayout>
      </Styles.PageLayout>
    );
  }
};

export default Intro;
